import { Model } from "@vuex-orm/core";
import shortid from "shortid";
import moment from "moment";

export default class Company extends Model {
  static entity = "companys";
  static fields() {
    return {
      id: this.attr("tmp/" + shortid.generate()),
      deliveryCompanyId: this.attr(null),
      zepplinId: this.attr(null),
      name: this.attr(null),
      description: this.attr(null),
      legalDocument: this.attr(null),
      activityArea: this.attr(null),
      status: this.attr(null),
      dateUpdated: this.attr(null),
      dateCreated: this.attr(moment().toISOString()),
      dateRemoved: this.attr(null),
    }
  }

}
